import(/* webpackMode: "eager" */ "/home/u704621842/domains/plenari.cat/hbuilds/source/repository/src/app/page.tsx");
